//#region ../schema-sql-parser/dist/parser/dataType/SQLite.js
var SQLiteTypes = [
	"BIGINT",
	"BLOB",
	"BOOL",
	"BOOLEAN",
	"CHARACTER",
	"CLOB",
	"DATE",
	"DATETIME",
	"DEC",
	"DECIMAL",
	"DOUBLE PRECISION",
	"DOUBLE",
	"FLOAT",
	"INT",
	"INT2",
	"INT8",
	"INTEGER",
	"MEDIUMINT",
	"NATIVE CHARACTER",
	"NCHAR",
	"NUMERIC",
	"NVARCHAR",
	"REAL",
	"SMALLINT",
	"TEXT",
	"TIME",
	"TIMESTAMP",
	"TINYINT",
	"UNSIGNED BIG INT",
	"VARCHAR",
	"VARYING CHARACTER"
];
//#endregion
export { SQLiteTypes };
